/**
 * Ruta PÚBLICA de la página de profesor (guest-first, sin cuenta):
 * `/teachers/<orgSlug>/<slug>` vive FUERA del árbol `/u/<n>` (como
 * `/verify/<certId>`) porque el enlace se comparte fuera de la app — un
 * visitante no tiene por qué tener sesión. Consume el REST público
 * `/api/public/teachers/:orgSlug/:slug`.
 */
import { createRoute, useParams } from "@tanstack/solid-router";
import { rootRoute } from "@/routes/__root";
import { PublicTeacherPageView } from "@/features/academy/components/people/public-teacher-page";
// B8 · asistente de la academia: es la superficie donde de verdad hay leads sin
// cuenta. El endpoint es público y su propio flag lo apaga; el widget no
// aparece si la academia no lo encendió (el servidor devuelve 403 y el widget
// se queda callado).
import { AcademyBotWidget } from "@/features/academy-bot/chat-widget";

function PublicTeacherPage() {
  const params = useParams({ from: "/teachers/$orgSlug/$slug" });
  return (
    <>
      <PublicTeacherPageView orgSlug={params().orgSlug} slug={params().slug} />
      <AcademyBotWidget orgSlug={params().orgSlug} />
    </>
  );
}

export const publicTeacherRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/teachers/$orgSlug/$slug",
  component: PublicTeacherPage,
});
